export const PARTNER_REGISTRATION_FORM_ID = 'partner_registration_form';

export const REWARD_POPUP_ID = 'reward_popup';

export const REWARD_BUTTON_ID = 'reward_button';
